module.exports = __webpack_public_path__ + "img/H000100_fishtail.d6db244d.png";